import { ui } from '@procuros/datachecks';
import { TFunction } from 'i18next';

type ErrorMessageConfig = {
  fieldType: ui.FieldTypes;
  columnOptions?: Array<{ label: string; value: string }>;
  t: TFunction;
};

export const getFieldFormatErrorMessage = (config: ErrorMessageConfig): string => {
  const { fieldType, columnOptions, t } = config;

  switch (fieldType) {
    case ui.FieldTypes.date:
      return t('priceCatalogs:template.errorDetails.formats.date');

    case ui.FieldTypes.date_time:
      return t('priceCatalogs:template.errorDetails.formats.date_time');

    case ui.FieldTypes.boolean:
      return t('priceCatalogs:template.errorDetails.formats.boolean');

    case ui.FieldTypes.number:
      return t('priceCatalogs:template.errorDetails.formats.number');

    case ui.FieldTypes.monetary:
      return t('priceCatalogs:template.errorDetails.formats.monetary');

    case ui.FieldTypes.select:
      return t('priceCatalogs:template.errorDetails.formats.select', {
        options: formatSelectOptions(columnOptions, t),
      });

    case ui.FieldTypes.text:
      return t('priceCatalogs:template.errorDetails.formats.text');

    default:
      return t('priceCatalogs:template.errorDetails.formats.text');
  }
};

const formatSelectOptions = (options: Array<{ label: string; value: string }> | undefined, t: TFunction): string => {
  if (!options || options.length === 0) {
    return '';
  }

  const translatedLabels = options.slice(0, 3).map((opt) => {
    const translated = t(opt.label, { defaultValue: opt.label });
    return translated;
  });

  if (options.length > 3) {
    return translatedLabels.join(', ') + ', ...';
  }
  return translatedLabels.join(', ');
};

/**
 * i18n
 * t('priceCatalogs:template.errorDetails.formats.date')
 * t('priceCatalogs:template.errorDetails.formats.date_time')
 * t('priceCatalogs:template.errorDetails.formats.boolean')
 * t('priceCatalogs:template.errorDetails.formats.number')
 * t('priceCatalogs:template.errorDetails.formats.monetary')
 * t('priceCatalogs:template.errorDetails.formats.select')
 * t('priceCatalogs:template.errorDetails.formats.text')
 */
